module.exports = __webpack_public_path__ + "img/CIS.1fca0d73.png";